import { useNavigate } from 'react-router-dom';
import { Users, Fuel, Settings2, Calendar, Gauge } from 'lucide-react';
import './CarCard.css';

export default function CarCard({ car }) {
  const navigate = useNavigate();

  return (
    <article className="card" onClick={() => navigate(`/car/${car.id}`)}>

      <div className="card__img-wrap">
        {car.image ? (
          <img src={car.image} alt={car.name} className="card__img" />
        ) : (
          <div className="card__img-placeholder">
            <span>{car.name[0]}</span>
          </div>
        )}
        <span className={car.available ? 'card__badge card__badge--available' : 'card__badge card__badge--taken'}>
          {car.available ? 'E Lirë' : 'E Zënë'}
        </span>
      </div>

      <div className="card__body">

        <div className="card__top">
          <span className="card__category">{car.category}</span>
          {car.engine && (
            <span className="card__engine">{car.engine}</span>
          )}
        </div>

        <h3 className="card__name">{car.name}</h3>

        <ul className="card__specs">
          <li><Users size={13} />{car.seats} ulëse</li>
          <li><Settings2 size={13} />{car.transmission}</li>
          <li><Fuel size={13} />{car.fuel}</li>
          <li><Calendar size={13} />{car.year}</li>
          {car.engine && (
            <li><Gauge size={13} />{car.engine}</li>
          )}
        </ul>

        <div className="card__cta">
          Shiko Detajet →
        </div>

      </div>

    </article>
  );
}